import { RoleType, User } from "../@types/Auth";

export const isDealerAdmin = (user: User | undefined): boolean => {
    const userRoleType = user?.attributes.type ?? '';
    return userRoleType === RoleType.DealerAdmin;
}